import { AlertTriangle } from "lucide-react";

export default function Disclaimer() {
  return (
    <div
      className="flex items-start gap-3 rounded-xl border p-4"
      style={{
        background: "#FDF6EC",
        borderColor: "#F0DEB8",
        color: "#7A5A1F",
      }}
      data-testid="medical-disclaimer"
    >
      <AlertTriangle className="h-5 w-5 flex-shrink-0 mt-0.5" strokeWidth={1.75} />
      <p className="text-sm leading-relaxed">
        <strong className="font-medium">This is not medical advice.</strong>{" "}
        SafeRxCheck shares general educational information about commonly prescribed
        medications. Always discuss labs, diet, supplements, and medication
        changes with a licensed clinician who knows your full history.
      </p>
    </div>
  );
}
